import React from 'react';
import styled from 'styled-components';
import { Text, TextAlignment } from '@volkswagen-onehub/components-core';
import { TextAppearance } from '@volkswagen-onehub/tokens';

const TextContainer = styled.div`
	position: absolute;
	top: -1px;
	background: linear-gradient(90deg, #b8b8b8 0%, #f0f0f0 26%, #c3c3c3 47%, #f4f4f4 70%, #b8b8b8 100%);
	border-radius: 500px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding-left: 32px;
	padding-right: 32px;
	min-height: 32px; // usamos min-height en vez de padding top/bottom para - no se puede calcular el breakpoint exacto que hace hacer el salto de línea
	min-width: 317px;

	/* Centrado por defecto */
	left: 50%;
	right: auto;
	transform: translate(-50%, -50%);
`;

const TextHighlight = styled(Text)`
	color: #001e50;
	text-wrap: balance;
	word-break: keep-all;
`;

export const SilverLabel = () => {
	return (
		<TextContainer>
			<TextHighlight appearance={TextAppearance.copy200} textAlign={TextAlignment.center} bold>
				Todo este tiempo juntos se merece...
			</TextHighlight>
		</TextContainer>
	);
};
